/* dta-spotify.js - theme asset v1.1 (11 Oct 2026: links never navigate the post's tab). Dean Turner Art per-person blog posts.
   Turns each a.dta-song__play[data-dta-spotify] in the post body into an in-page Spotify player.
   Nothing from Spotify loads until the reader taps. One player open at a time; tapping again closes it (stops the sound).
   Without this file the same links just open the track on Spotify, so the post still works. */
(function(){
  /* No Spotify link ever navigates the post's own tab (Scott, 11 Oct 2026). Every play link and every "Open in Spotify"
     link gets target=_blank rel=noopener first (the editor strips target/rel, so they are set here); a plain tap on a play
     link is then always cancelled and toggles the in-page player; modifier/middle clicks can only open a NEW tab. */
  Array.prototype.forEach.call(document.querySelectorAll('.dta-person a.dta-song__play, .dta-person a.dta-song__open'),function(a){
    a.target='_blank'; a.rel='noopener';
  });
  var links=document.querySelectorAll('.dta-person a.dta-song__play[data-dta-spotify]');
  if(!links.length) return;
  var open=null, n=0;
  function close(a){
    var box=document.getElementById(a.getAttribute('aria-controls'));
    if(box) box.parentNode.removeChild(box);
    a.classList.remove('is-open'); a.setAttribute('aria-expanded','false');
    a.querySelector('.dta-vh').textContent=a.getAttribute('data-label-play');
    if(open===a) open=null;
  }
  function play(a){
    if(open&&open!==a) close(open);
    var id=a.getAttribute('data-dta-spotify'); if(!/^[A-Za-z0-9]{22}$/.test(id)) return false;
    var li=a.parentNode, box=document.createElement('div');
    box.className='dta-song__player'; box.id=a.getAttribute('aria-controls'); box.textContent='Loading Spotify player\u2026';
    var f=document.createElement('iframe');
    f.src='https://open.spotify.com/embed/track/'+id+'?utm_source=generator&theme=0';
    f.title='Spotify player: '+a.getAttribute('data-song');
    f.width='100%'; f.height='80'; f.setAttribute('frameborder','0');
    f.allow='autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';
    f.addEventListener('load',function(){ if(box.firstChild&&box.firstChild.nodeType===3) box.removeChild(box.firstChild); });
    box.appendChild(f); li.appendChild(box);
    a.classList.add('is-open'); a.setAttribute('aria-expanded','true');
    a.querySelector('.dta-vh').textContent='Close the Spotify player for '+a.getAttribute('data-song');
    open=a; return true;
  }
  Array.prototype.forEach.call(links,function(a){
    var vh=a.querySelector('.dta-vh'); if(!vh) return;
    a.setAttribute('role','button'); a.setAttribute('aria-expanded','false');
    a.setAttribute('aria-controls','dta-sp-'+(++n));
    a.setAttribute('data-label-play',vh.textContent);
    a.setAttribute('data-song',vh.textContent.replace(/^Play /,''));
    a.addEventListener('click',function(e){
      if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button>0) return;   /* new-tab clicks still go to Spotify */
      e.preventDefault();
      if(a.classList.contains('is-open')) close(a);
      else if(!play(a)) window.open(a.href,'_blank','noopener');   /* bad id: open in a new tab, never this one */
    });
    a.addEventListener('keydown',function(e){ if(e.key===' '||e.key==='Spacebar'){ e.preventDefault(); a.click(); } });
  });
})();
